import { PaymentFormattedLI } from '@bcraft-frontend-lib/payments'

import { LocalePaymentKeysType } from 'shared/locale/en-US'

export const dateFormatRequest = 'YYYY-MM-DD'
export const timeFormatRequest = 'HH:mm:ss'
export const dateFormatRequestFull = 'YYYY-MM-DDTHH:mm:ssZ'

export const additionalDepositSystems: PaymentFormattedLI[] = [
  // {
  //   name: 'mobcash',
  //   method: 'mobcash',
  //   slug: 'mobcash_cash',
  //   currency: '',
  //   fields: [],
  //   min: 0,
  //   max: 0,
  //   isDisabled: false,
  //   requisites: [],
  // },
]

export interface IDepositWritingFormatItem {
  textID: LocalePaymentKeysType
}

export const depositWritingFormatItems: IDepositWritingFormatItem[] = [
  { textID: 'depositWithMethod' },
  { textID: 'userId' },
  { textID: 'transactionId' },
  { textID: 'clientPhone' },
  { textID: 'agentNumber' },
  { textID: 'date' },
  { textID: 'time' },
  { textID: 'amount' },
]

export const allowedCryptoCurrencies: string[] = ['usdttrc20']
